import {
  Component,
  effect,
  model,
  ModelSignal,
  output,
  OutputEmitterRef,
  signal,
  WritableSignal,
} from '@angular/core';
import { TranscriptionSegment } from '../../models/translated-segment.model';
import { LucideAngularModule } from 'lucide-angular';

@Component({
  selector: 'app-transcription-segment-editor',
  imports: [LucideAngularModule],
  templateUrl: './transcription-segment-editor.component.html',
  styleUrl: './transcription-segment-editor.component.scss',
})
export class TranscriptionSegmentEditorComponent {
  segment: ModelSignal<TranscriptionSegment | undefined> = model();
  delete: OutputEmitterRef<void> = output<void>();
  cancel: OutputEmitterRef<void> = output<void>();
  play: OutputEmitterRef<TranscriptionSegment> = output<TranscriptionSegment>();
  modifiedText: WritableSignal<string | undefined> = signal(undefined);

  textChange(event: Event) {
    const value: string = (event.target as HTMLInputElement).value;
    this.modifiedText.set(value);
  }

  onSave(): void {
    if (!this.segment() || !this.modifiedText()) return;
    const modifiedSegment: TranscriptionSegment = {
      text: this.modifiedText()!,
      start: this.segment()!.start,
      end: this.segment()!.end,
    };
    this.segment.set(modifiedSegment);
  }

  constructor() {
    effect(() => {
      this.modifiedText.set(this.segment()?.text);
    });
  }
}
